import 'slick-carousel/slick/slick.min.js';

class Timeline {
  init() {
    this.initSlides();
    $( '.timeline__decade__button' ).on( 'click', (e) => this.changeTabs(e) );
  }

  initSlides() {
    $('.timeline__years__decade--active .timeline__years__slideshow:not(.slick-initialized)').slick({
      // autoplay: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      appendArrows: $( '.page-slideshow__arrows' ),
      asNavFor: '.timeline__years__decade--active .timeline__years__thumbnails',
      rows: 0,
    });

    $('.timeline__years__decade--active .timeline__years__thumbnails:not(.slick-initialized)').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      focusOnSelect: true,
      variableWidth: true,
      asNavFor: '.timeline__years__decade--active .timeline__years__slideshow',
      rows: 0,
    });
  }

  changeTabs(e) {
    e.preventDefault();
    const selection = $(e.currentTarget);
    const tabId = selection.data('tab');

    $('.timeline__decade--active').removeClass('timeline__decade--active');
    $('.timeline__years__decade--active').removeClass('timeline__years__decade--active');
    $('.timeline__decade--past').removeClass('timeline__decade--past');

    selection.parent().addClass('timeline__decade--active');
    $( '#' + tabId ).addClass('timeline__years__decade--active');

    // this.updateTimelineDecade();
    this.initSlides();
  }

  updateTimelineDecade() {
    const activeDecade = $('.timeline__decade--active');
    const currentTabIndex = $('.timeline__decade').index(activeDecade);

    $('.timeline__decade').each(function(i) {
      if (i < currentTabIndex) {
        $(this).addClass('timeline__decade--past');
      }
    });
  }
}

export default {
  init() {
    const timeline = new Timeline();

    timeline.init();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/customTimeline.js